import AuthApi from './AuthApi'

export default AuthApi